import React from 'react';
import CategoryBase from '../Component/CategoryBase';

const CategoryPredominantRace = () => {
  return <CategoryBase baseEndpoint="category_predominant_race" />;
};

export default CategoryPredominantRace;
